import React, { Component } from "react";
import project from "../config";
const flashIcon = require(`../assets/${project.assets}/img/flashIcon.png`);

class Teleport extends Component {
	state = {
		selectedFloor: 0,
		teleportData: [],
	};

	constructor(props) {
		super(props);
		let { apiData } = this.props;

		let tempState = {
			teleportData: [],
			selectedFloor: 0,
		};

		for (const item of apiData.data.visualisation.maps.levels) {
			for (const level of item.teleports) {
				if (level.start) {
					tempState.selectedFloor = parseInt(item.unreal_id);
					break;
				}
			}
			tempState.teleportData.push({
				floorId: item.unreal_id,
				floorName: item.label.de,
				mapImage: item.image_url,
				floorPoints: item.teleports,
			});
		}

		this.state = { ...tempState };
	}

	render() {
		let { mapClass, currentData, onShowHide, pointClick, floorClick } =
			this.props;
		let { teleportData } = this.state;

		function handleClick(ueCMD) {
			pointClick(ueCMD);
		}
		function handleFloor(id) {
			floorClick(id);
		}

		return (
			<div className={"telContainer " + mapClass}>
				<div className="telFloorContainer">
					{teleportData.map((data, id) => (
						<div
							key={id}
							className={
								parseInt(data.floorId) == currentData[1] ? "active" : ""
							}
							onClick={() => handleFloor(parseInt(data.floorId))}
						>
							{data.floorName}
						</div>
					))}
				</div>

				<div className="telMapContainer">
					<img src={teleportData[currentData[1] - 1].mapImage} alt="" />
					{teleportData[currentData[1] - 1].floorPoints.map((point, id) => (
						<div
							key={id}
							onClick={() => handleClick(point.unreal_id)}
							className={
								parseInt(point.unreal_id.slice(-2)) === parseInt(currentData[0])
									? "telPoint telActive"
									: "telPoint"
							}
							style={{ top: point.map_y - 7, left: point.map_x - 7 }}
						></div>
					))}
				</div>
				<div onClick={onShowHide} className="telBtn">
					<img src={flashIcon} alt="" />
				</div>
			</div>
		);
	}
}

export default Teleport;
